/** @format */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";

const INITIAL_STATE = {
	email: "",
	password: "",
	error: null,
};

class AdminLogin extends Component {
	constructor(props) {
		super(props);

		this.state = { ...INITIAL_STATE };

		this.onHandleChange = this.onHandleChange.bind(this);
		this.onHandleSubmit = this.onHandleSubmit.bind(this);
	}

	onHandleChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onHandleSubmit(e) {
		e.preventDefault();
	}

	render() {
		const { email, password } = this.state;
		return (
			<div>
				<nav>
					<div className="header">
						<Link to="/">
							<img src={Logo} alt="" className="logo" />
						</Link>
					</div>
				</nav>
				<div className="d-flex justify-content-center">
					<form onSubmit={this.onHandleSubmit}>
						<div className="form-group">
							<input
								type="email"
								name="email"
								value={email}
								onChange={this.onHandleChange}
								placeholder="Email Address"
							/>
						</div>
						<div className="form-group">
							<input
								type="password"
								name="password"
								value={password}
								onChange={this.onHandleChange}
								placeholder="password"
							/>
						</div>
						<div className="form-group">
							<button className="btn btn-success btn-submit">
								Login
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default AdminLogin;
